import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route (pathname) changes, so
 * navigating via the nav menu always lands at the top of the page. Keyed on
 * pathname only — query-param and in-page #anchor changes are left alone.
 *
 * Uses an explicit `behavior: "instant"` rather than the `window.scrollTo(0, 0)`
 * shorthand — the global `html { scroll-behavior: smooth }` (shadcn-theme.css,
 * kept for anchor links and other intentional smooth scrolls) would otherwise
 * animate every route change, which reads as a jarring scroll-down-then-up.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
